import qs from 'qs';
import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/ext/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/`
);

const saveEmailSettings = async (
  settings: object,
  reason: object,
  options: object
) => {
  try {
    const response = await axios.post(
      `settings/update-email`,
      qs.stringify({
        settings: JSON.stringify(settings),
        reason: JSON.stringify(reason),
      }),
      options
    );
    if (response[STATUS] === 200) {
      return response?.data?.settings;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const getEmailSettings = async (options = {}) => {
  try {
    const response = await axios.get(`settings/email`, options);
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const sendActivationOtp = async (
  otpInfo: {
    email?: string;
    forWhat?: string;
    otpBy?: number;
  },
  options: object
) => {
  try {
    const response = await axios.post(
      `/twoFactorAuth/send-otp`,
      qs.stringify(otpInfo),
      options
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const activateAccount = async (otp: string, options: object) => {
  try {
    const response = await axios.post(
      `/activate/account`,
      qs.stringify({otp}),
      options
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const unsubscribe = {
  saveEmailSettings,
  getEmailSettings,
  sendActivationOtp,
  activateAccount,
};

export default unsubscribe;
